var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Attribute, Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
// Got from: https://scotch.io/tutorials/how-to-implement-a-custom-validator-directive-confirm-password-in-angular-2
var EqualValidator = /** @class */ (function () {
    function EqualValidator(validateEqual, reverse) {
        this.validateEqual = validateEqual;
        this.reverse = reverse;
    }
    EqualValidator_1 = EqualValidator;
    Object.defineProperty(EqualValidator.prototype, "isReverse", {
        get: function () {
            if (!this.reverse) {
                return false;
            }
            return this.reverse === 'true';
        },
        enumerable: true,
        configurable: true
    });
    EqualValidator.prototype.validate = function (control) {
        var pairControl = control.root.get(this.validateEqual);
        if (!pairControl) {
            return null;
        }
        var value = control.value;
        var pairValue = pairControl.value;
        if (!value && !pairValue) {
            return null;
        }
        if (this.isReverse) {
            if (value === pairValue) {
                if (pairControl.errors) {
                    delete pairControl.errors['validateEqual'];
                }
                if (!Object.keys(pairControl.errors).length) {
                    pairControl.setErrors(null);
                }
            }
            else {
                pairControl.setErrors({
                    validateEqual: true
                });
            }
            return null;
        }
        else {
            if (value !== pairValue) {
                return {
                    validateEqual: true
                };
            }
        }
    };
    var EqualValidator_1;
    EqualValidator = EqualValidator_1 = __decorate([
        Directive({
            selector: '[validateEqual][formControlName],[validateEqual][formControl],[validateEqual][ngModel]',
            providers: [
                { provide: NG_VALIDATORS, useExisting: forwardRef(function () { return EqualValidator_1; }), multi: true }
            ]
        }),
        __param(0, Attribute('validateEqual')),
        __param(1, Attribute('reverse'))
    ], EqualValidator);
    return EqualValidator;
}());
export { EqualValidator };
